module.exports = __webpack_public_path__ + "img/sand-dune-decal-07.450ae8d3.png";